export default __webpack_public_path__ + "static/media/Group 9056.1324fc70.png";